import { OptimizeResults } from '~/features/x-ray/types/optimize';
import { sylvanus } from '~/services/serviceInstances';
import { Uuid } from '~/types/Uuid';

import { OptimizeRun } from '../../types/sylvanus/model';
import { mapOptimizeResults } from './transformers';

interface Request {
  modelId: Uuid;
  version: number;
  highlightMethod: string;
}

type Response = OptimizeRun;

export const getPromptModelOptimizeResults = async ({
  modelId,
  version,
  highlightMethod,
}: Request): Promise<OptimizeResults> => {
  const response: Response = await sylvanus.get(
    `/model/${modelId}/version/${version}/optimize`,
  );
  return mapOptimizeResults(response, highlightMethod);
};
